import { useState, useEffect } from "react"
import { Box, Typography, Switch, FormControlLabel, Divider, Slider, Button } from "@mui/material"

export default function AccessibilityPanel() {
  const [highContrast, setHighContrast] = useState(false)
  const [largeText, setLargeText] = useState(false)
  const [underlineLinks, setUnderlineLinks] = useState(false)
  const [fontScale, setFontScale] = useState(1)

  // Load settings from localStorage on mount
  useEffect(() => {
    const savedContrast = localStorage.getItem("access_highContrast") === "true"
    const savedLargeText = localStorage.getItem("access_largeText") === "true"
    const savedUnderline = localStorage.getItem("access_underlineLinks") === "true"
    const savedFontScale = parseFloat(localStorage.getItem("access_fontScale") || "1")

    setHighContrast(savedContrast)
    setLargeText(savedLargeText)
    setUnderlineLinks(savedUnderline)
    setFontScale(savedFontScale)

    if (savedContrast) document.body.classList.add("high-contrast")
    if (savedLargeText) document.body.classList.add("large-text")
    if (savedUnderline) document.body.classList.add("underline-links")
    document.documentElement.style.setProperty("--app-font-scale", savedFontScale.toString())
  }, [])

  // Toggle high contrast
  const toggleHighContrast = () => {
    const newValue = !highContrast
    setHighContrast(newValue)
    localStorage.setItem("access_highContrast", newValue)
    document.body.classList.toggle("high-contrast", newValue)
  }

  // Toggle large text
  const toggleLargeText = () => {
    const newValue = !largeText
    setLargeText(newValue)
    localStorage.setItem("access_largeText", newValue)
    document.body.classList.toggle("large-text", newValue)
  }

  // Toggle underline links
  const toggleUnderlineLinks = () => {
    const newValue = !underlineLinks
    setUnderlineLinks(newValue)
    localStorage.setItem("access_underlineLinks", newValue)
    document.body.classList.toggle("underline-links", newValue)
  }

  // Handle font scale
  const handleFontScaleChange = (event, value) => {
    const scale = Array.isArray(value) ? value[0] : value
    setFontScale(scale)
    localStorage.setItem("access_fontScale", scale)
    document.documentElement.style.setProperty("--app-font-scale", scale.toString())

    setLargeText(true)
    localStorage.setItem("access_largeText", true)
    document.body.classList.toggle("large-text", true)
  }

  // Reset all
  const resetAll = () => {
    setHighContrast(false)
    setLargeText(false)
    setUnderlineLinks(false)
    setFontScale(1)

    localStorage.removeItem("access_highContrast")
    localStorage.removeItem("access_largeText")
    localStorage.removeItem("access_underlineLinks")
    localStorage.removeItem("access_fontScale")

    document.body.classList.remove("high-contrast", "large-text", "underline-links")
    document.documentElement.style.setProperty("--app-font-scale", "1")
  }

  return (
    <Box
      p={2}
      width={280}
      sx={{
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Typography variant='h6' gutterBottom>
        נגישות
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <FormControlLabel
        control={<Switch checked={highContrast} onChange={toggleHighContrast} />}
        label='ניגודיות גבוהה'
      />

      <FormControlLabel
        control={<Switch checked={largeText} onChange={toggleLargeText} />}
        label='טקסט גדול'
      />

      <FormControlLabel
        control={<Switch checked={underlineLinks} onChange={toggleUnderlineLinks} />}
        label='הדגשת קישורים'
      />

      <Box mt={3}>
        <Typography variant='body2' gutterBottom>
          קנה מידה לטקסט
        </Typography>
        <Slider
          value={fontScale}
          min={0.8}
          max={2.0}
          step={0.1}
          onChange={handleFontScaleChange}
          valueLabelDisplay='auto'
        />
      </Box>

      <Box mt={3}>
        <Button fullWidth variant='outlined' onClick={resetAll}>
          איפוס
        </Button>
      </Box>
    </Box>
  )
}
